import React from "react";
import Slide, { SlideProps } from "@mui/material/Slide";

const Transition = React.forwardRef<unknown, SlideProps>(function Transition(
  props,
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default Transition;
